import { AccordionDetailsList } from '../AccordionDetailsList';
import { PortfolioAccordionDetails } from '../PortfolioAccordionDetails';

import { AppreciationDetailsList, AppreciationDetailsListProps } from '../../../common/detailsList';

export const AppreciationAccordionDetails = (props: AppreciationDetailsListProps) => {
  return (
    <PortfolioAccordionDetails>
      <AccordionDetailsList>
        <AppreciationDetailsList {...props} />
      </AccordionDetailsList>
    </PortfolioAccordionDetails>
  );
};
